import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { PruToast } from "../../../../components/pru-toast";
import { ONBOARDING_PATH, ROOT_PATH } from "../../../../routes/constants";
import { exchangeCodeForTokenAsync } from "../../../auth/redux/auth-slice";
import { RoleEnum } from "../../types";
import { fakeToken, parseJwt } from "../../utils";
import { useA2HS } from "../../../../utils/hooks/use-a2hs";
import { clearSessionStorage } from "../login/login.hook";
import { SESSION_STORAGE_KEY } from "../../../../utils/session-storage";

export const SSOCallbackScreen = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { triggerA2HSPrompt, isInPWAMode } = useA2HS();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get("authorizationCode");

    if (code) {
      dispatch(exchangeCodeForTokenAsync(code) as any)
        .unwrap()
        .then(async () => {
          const token = sessionStorage.getItem(SESSION_STORAGE_KEY.AUTH_TOKEN);
          if (token && token !== fakeToken) {
            const tokenData = parseJwt(token.replace("Bearer ", ""));

            if (!isInPWAMode) {
              triggerA2HSPrompt();
            }

            // Check if there are stored routes and state."
            const lastPath = sessionStorage.getItem(SESSION_STORAGE_KEY.LAST_PATH);
            const navigateState = JSON.parse(
              sessionStorage.getItem(SESSION_STORAGE_KEY.LAST_NAVIGATE_STATE) || "{}",
            );
            const lastAuthToken = sessionStorage.getItem(SESSION_STORAGE_KEY.LAST_AUTH_TOKEN);

            if (tokenData && lastAuthToken) {
              const currentCandidateId = tokenData?.sub;
              const lasttCandidateId = parseJwt(lastAuthToken)?.sub;

              if (lastPath && currentCandidateId === lasttCandidateId) {
                navigate(lastPath, { state: navigateState });
                clearSessionStorage();
                return;
              }
            }
            if (tokenData?.role === RoleEnum.CANDIDATE) {
              navigate(`${ROOT_PATH}/${ONBOARDING_PATH}/candidate-home`);
            } else if (tokenData?.role === RoleEnum.PENDING_CANDIDATE) {
              navigate(`${ROOT_PATH}/${ONBOARDING_PATH}/join-now`);
            } else {
              PruToast({
                message: "Invalid role",
                status: "error",
              });
              navigate(`${ROOT_PATH}/login`);
            }
          } else {
            PruToast({
              message: "Invalid token",
              status: "error",
            });
            navigate(`${ROOT_PATH}/login`);
          }
        })
        .catch((error: string) => {
          PruToast({ message: error, status: "error" });
          navigate(`${ROOT_PATH}/login`);
        });
    } else {
      navigate(`${ROOT_PATH}/login`);
    }
  }, [dispatch, location, navigate, triggerA2HSPrompt, isInPWAMode]);

  return <CircularProgress sx={{ margin: "20% 50%" }} />;
};
